"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var fieldTypes = _interopRequireWildcard(require("customer-data-objects/property/PropertyFieldTypes"));

var _PropertyRecord = _interopRequireDefault(require("customer-data-objects/property/PropertyRecord"));

var _PropertyTypes = require("customer-data-objects/property/PropertyTypes");

var _default = (0, _PropertyRecord.default)({
  displayOrder: -1,
  externalOptions: true,
  favoritedOrder: -1,
  fieldType: fieldTypes.NUMBER,
  formField: true,
  groupName: 'dealinformation',
  hidden: false,
  hubspotDefined: true,
  label: 'Deal Stage Probability',
  name: 'dealstage.probability',
  readOnlyDefinition: true,
  readOnlyValue: true,
  type: _PropertyTypes.NUMBER
});

exports.default = _default;
module.exports = exports.default;